<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar'

export default {
    props: {
        height: Number,
    },
    components: {
        VuePerfectScrollbar,
    },
    computed: {
        style() {
            return {
                'max-height': `${this.height || 320}px`,
            };
        },
    },
    data() {
        return {
            settings: {
                suppressScrollX: true,
                wheelPropagation: true,
                maxScrollbarLength: 50,
                minScrollbarLength: 50,
            },
        };
    },
};
</script>

<template>
    <vue-perfect-scrollbar class="Scrollbar" :settings="settings" :style="style">
        <div class="ScrollbarInner">
            <slot></slot>
        </div>
    </vue-perfect-scrollbar>
</template>

<style lang="stylus">
@import '../../stylus/vars.styl'

.Scrollbar
    padding 0 20px 0 0
    overflow hidden !important
    .ps__scrollbar-y-rail
        display block !important
        opacity 1 !important
        background $cBorder !important
        width 4px !important
        .ps__scrollbar-y
            background $cAccent !important
            width 4px !important
            right 0 !important

</style>


